import * as api from "@/api/williams/search";
import { GlobalSearchFilters } from "@/api/williams/search";
import { queryKeys } from "../../queryKeys";
import { useInfiniteQuery } from "react-query";

const PAGE_SIZE = 100;

export function useGlobalSearch(filters: Partial<GlobalSearchFilters> = {}) {
  return useInfiniteQuery({
    queryKey: queryKeys.search.global(filters),
    queryFn: ({ pageParam = 0 }) => {
      const skip = pageParam * PAGE_SIZE;
      return api.globalSearch({ skip, take: PAGE_SIZE, ...filters });
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.results.length === PAGE_SIZE) {
        return allPages.length;
      }
    },
    enabled: Boolean(filters.searchString || filters.ownerId || filters.specialistId),
  });
}
